import { createSelector } from 'reselect';

export function getSpecialtiesLists(state) {
  return state.specialties;
}

export function getSpecialtiesListsById(state, currentSpecialtiesListId) {
  return getSpecialtiesLists(state).get(currentSpecialtiesListId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentSpecialtiesLists = createSelector(
  getSpecialtiesLists,
  specialties => specialties.get(specialties.get('currentSpecialtiesListId'))
);
